import { createAction } from 'lib/store-utils';

export const BOX_SETTINGS_LAYOUT_PAGE_CLOSED = createAction('settings layout / page closed');
export const BOX_SETTINGS_LAYOUT_ERRORS_CLEARED = createAction('settings layout / errors cleared');
